import Button from '@/components/Button'

type KitPaginationControlsProps = {
    pageNumber: number
    itemCount: number
    perPage: number
    hasMore: boolean
    isLoading: boolean
    onPrevious: () => void
    onNext: () => void
}

export default function KitPaginationControls({
    pageNumber,
    itemCount,
    perPage,
    hasMore,
    isLoading,
    onPrevious,
    onNext,
}: KitPaginationControlsProps): React.JSX.Element {
    return (
        <div className="mt-4 flex items-center justify-between text-sm text-gray-600">
            <Button
                type="button"
                style="secondary"
                onClick={onPrevious}
                enabled={pageNumber > 1 && !isLoading}
            >
                Previous
            </Button>
            <div>
                Page {pageNumber} | Showing {itemCount} | Per page {perPage}
            </div>
            <Button
                type="button"
                style="secondary"
                onClick={onNext}
                enabled={hasMore && !isLoading}
            >
                Next
            </Button>
        </div>
    )
}
